import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { MenuAsideService, SubheaderService } from '../../../../core/_base/layout';
import { UserService } from '../../../../provider/user.service';
import { AppHotelService } from '../../../../provider/app-hotel.service';
import { AppHotelModel } from 'src/app/views/models/app-hotel.model';
import { RequestsService } from 'src/app/provider/requests.service';
import { RequestHeaderModel } from 'src/app/views/models/request-header.model';
import * as dayjs from 'dayjs';
import { TokenFormModel } from '../../auth/models/tokenform.model';

@Component({
  selector: 'kt-welcome',
  templateUrl: './welcome.page.html',
  styleUrls: ['./welcome.page.scss']
})
export class WelcomePage implements OnInit {
  orderSummary: OrderSummaryReportModel;
  top10Products: Top10ProductReportModel[] = [];
  filteredProducts: Top10ProductReportModel[] = [];
  paginatedProducts: Top10ProductReportModel[] = [];
  top3ProductsStatic: Top10ProductReportModel[] = [];
  last3YearsRevenue: any[] = [];
  mockRanks = [0, 1, 2]; // For empty state

  // Pagination
  currentPage = 1;
  pageSize = 5;

  // Search
  searchQuery = '';

  selectedValue = 'thisYear';
  loading = true;
  loadingProducts = false;
  data = null;
  nullFacilities = [];
  isInfoNull = false;
  startedWizard = false;
  isMoreNull = false;
  fullProfile: boolean = (localStorage.getItem('fullProfile') === 'ok');
  profile: TokenFormModel = JSON.parse(localStorage.getItem('token_form'));

  hotelInfo: AppHotelModel = null;

  controlgroups = [
    {
      name: 'Hotel Information',
      controlValues: [
        { name: 'name', isNull: true },
        { name: 'contact_name', isNull: true },
        { name: 'contact_phone', isNull: true },
        { name: 'contact_email', isNull: true },
        { name: 'call_center', isNull: true },
        { name: 'master_color', isNull: true },
        { name: 'sub_color', isNull: true },
        { name: 'address', isNull: true },
        { name: 'post_code', isNull: true },
        { name: 'city', isNull: true },
        { name: 'country', isNull: true },
        { name: 'currency_code', isNull: true },
        { name: 'languages', isNull: true },
        { name: 'web_site_url', isNull: true },
        { name: 'lat_lng', isNull: true },
        { name: 'hotel_information_', isNull: true },
        { name: 'kvvk_link', isNull: true },
        { name: 'privacy_policy_link', isNull: true },
        { name: 'sp_doctor', isNull: true },
        { name: 'sp_reception', isNull: true },
        { name: 'sp_room_service', isNull: true },
        { name: 'sp_customer_relation', isNull: true },
        { name: 'sp_technical_service', isNull: true },
        { name: 'sp_management', isNull: true },
        { name: 'sm_youtube_url', isNull: true },
        { name: 'sm_instagram_url', isNull: true },
        { name: 'sm_facebook_url', isNull: true },
        { name: 'sm_twitter_url', isNull: true },
        { name: 'sm_vkontakte_url', isNull: true },
        { name: 'sub_domain_name', isNull: true },
        { name: 'baby_age_range', isNull: true },
        { name: 'child_age_range', isNull: true },
        { name: 'old_age_range', isNull: true },
        { name: 'wifi_name', isNull: true },
        { name: 'wifi_passwod', isNull: true },
        { name: 'dark_logo', isNull: true },
        { name: 'light_logo', isNull: true },
        { name: 'logo', isNull: true },
        { name: 'slider_images', isNull: true },
        { name: 'title_and_descriptions', isNull: true },
      ],
      isNull: false
    },
    {
      name: 'Facilities',
      controlValues: [
        { name: 'bars', isNull: true },
        { name: 'golf_club', isNull: true },
        { name: 'cafes', isNull: true },
        { name: 'kids_club', isNull: true },
        { name: 'rooms', isNull: true },
        { name: 'massage', isNull: true },
        { name: 'meeting_rooms', isNull: true },
        { name: 'pools', isNull: true },
        { name: 'restaurants', isNull: true },
        { name: 'spa', isNull: true },
        { name: 'sport', isNull: true },
        { name: 'amenities', isNull: true },
        { name: 'housekeeping', isNull: true },
        { name: 'issues', isNull: true },
        { name: 'complaint', isNull: true },
        { name: 'other_services', isNull: true },
        { name: 'room_services', isNull: true },
        { name: 'activity', isNull: true },
        { name: 'daily_animations', isNull: true },
        { name: 'shows', isNull: true },
        { name: 'po_is', isNull: true },
        { name: 'tours', isNull: true },
        { name: 'opportunities', isNull: true },
        { name: 'news', isNull: true },
        { name: 'loyality_management', isNull: true },
        { name: 'room_guide', isNull: true },
        { name: 'malls', isNull: true },
        { name: 'front_office', isNull: true },
        { name: 'mice', isNull: true },
        { name: 'wedding', isNull: true },
        { name: 'avm', isNull: true },
        { name: 'life', isNull: true },
        { name: 'events', isNull: true },
        { name: 'cinema', isNull: true },
      ],
      isNull: true
    }
  ];

  constructor(
    private subheaderService: SubheaderService,
    public userService: UserService,
    public appHotel: AppHotelService,
    private menuAsideService: MenuAsideService,
    private reqServ: RequestsService,
    private cdr: ChangeDetectorRef
  ) {
    this.menuAsideService.pathname$.next(window.location.pathname);
    this.subheaderService.title$.next({ title: 'Home', desc: '' });
    setInterval(() => {
      this.appHotel.getStatistics(this.profile.app_hotel_id, 'day');
    }, 60 * 1000 * 10);
    this.appHotel.getStatistics(this.profile.app_hotel_id, 'day');

  }

  async ngOnInit() {
    if (localStorage.getItem('wizard') !== null) {
      this.startWizard();
    }

    this.hotelInfo = await this.appHotel.getAppHotel(JSON.parse(localStorage.getItem('token_form')).app_hotel_id) as AppHotelModel;
    this.appHotel.getHotelImage(Number(JSON.parse(localStorage.getItem('token_form')).app_hotel_id), 'Slider');

    // Load static data once (not affected by filter)
    await this.loadStaticChartData();

    await this.calcStatics('thisYear');
    this.cdr.detectChanges();
  }

  // Load static chart data (called once on init)
  async loadStaticChartData() {
    const currentYear = new Date().getFullYear();
    
    // Get top 3 products for this year (static)
    const yearStart = `${currentYear}-01-01`;
    const yearEnd = `${currentYear}-12-31`;
    
    try {
      const allProducts = await this.reqServ.getTop10ProductSummaryReport(yearStart, yearEnd);
      // Filter out invalid products and take top 3
      const validProducts = allProducts.filter(p => p.description && p.description.trim() !== '' && p.total_amount > 0);
      this.top3ProductsStatic = validProducts.slice(0, 3);
      this.cdr.detectChanges();
    } catch (error) {
      console.error('Error loading top 3 products:', error);
      this.top3ProductsStatic = [];
      this.cdr.detectChanges();
    }

    // Get last 3 years revenue data (static)
    this.last3YearsRevenue = [];
    for (let i = 2; i >= 0; i--) {
      const year = currentYear - i;
      const startDate = `${year}-01-01`;
      const endDate = `${year}-12-31`;
      
      try {
        const summary = await this.reqServ.getOrderSummaryReport(startDate, endDate);
        this.last3YearsRevenue.push({
          year: year,
          amount: summary.total_amount || 0
        });
      } catch (error) {
        this.last3YearsRevenue.push({
          year: year,
          amount: 0
        });
      }
    }
    this.cdr.detectChanges();
  }


  async calcStatics(type: string) {
    this.loadingProducts = true;
    this.cdr.detectChanges();

    let startDate = '';
    let endDate = '';
    switch (type) {
      case 'thisYear':
        startDate = dayjs().startOf('year').format('YYYY-MM-DD');
        endDate = dayjs(new Date()).format('YYYY-MM-DD');
        break;
      case 'lastYear':
        startDate = dayjs().startOf('year').add(-1, 'year').format('YYYY-MM-DD');
        endDate = dayjs(startDate).endOf('year').format('YYYY-MM-DD');
        break;
      case 'thisMonth':
        startDate = dayjs().startOf('month').format('YYYY-MM-DD');
        endDate = dayjs().endOf('month').format('YYYY-MM-DD');
        break;
      case 'lastMonth':
        startDate = dayjs().startOf('month').add(-1, 'month').format('YYYY-MM-DD');
        endDate = dayjs(startDate).endOf('month').format('YYYY-MM-DD');
        break;
      case 'thisWeek':
        startDate = dayjs().startOf('week').format('YYYY-MM-DD');
        endDate = dayjs().endOf('week').format('YYYY-MM-DD');
        break;
      case 'lastWeek':
        startDate = dayjs().startOf('week').add(-1, 'week').format('YYYY-MM-DD');
        endDate = dayjs(startDate).endOf('week').format('YYYY-MM-DD');
        break;
      case 'today':
        startDate = dayjs(new Date()).format('YYYY-MM-DD');
        endDate = startDate;
        break;
      case 'yesterday':
        startDate = dayjs(new Date()).add(-1, 'day').format('YYYY-MM-DD');
        endDate = startDate;
        break;
    }
    this.top10Products = [];

    try {
      this.orderSummary = await this.reqServ.getOrderSummaryReport(startDate, endDate);
      const allProducts = await this.reqServ.getTop10ProductSummaryReport(startDate, endDate);
      
      // Filter out invalid products (no description or no amount)
      this.top10Products = allProducts.filter(p => 
        p.description && 
        p.description.trim() !== '' && 
        p.total_amount > 0
      );
      
      // Reset pagination and filter when data changes
      this.searchQuery = '';
      this.filteredProducts = this.top10Products.slice();
      this.currentPage = 1;
      this.updatePaginatedProducts();
      this.cdr.detectChanges();
    } catch (error) {
      console.error('Error loading statistics:', error);
      this.top10Products = [];
      this.filteredProducts = [];
      this.paginatedProducts = [];
      this.cdr.detectChanges();
    } finally {
      this.loadingProducts = false;
      this.cdr.detectChanges();
    }
  }

  startWizard() {
    if (localStorage.getItem('fullProfile') !== 'ok') {
      this.startedWizard = true;
      this.appHotel.getRichData(JSON.parse(localStorage.getItem('token_form')).app_hotel_id).subscribe((resp) => {
        this.data = resp;
        for (const controlData of this.controlgroups) {
          for (const control of controlData.controlValues) {
            if (controlData.name === 'Hotel Information') {
              if (this.data[`${control.name}`] !== '') {
                control.isNull = false;
              }
            } else {

              if (this.data[`${control.name}`].show) {
                if (this.data[`${control.name}`].menu_categories !== undefined && this.data[`${control.name}`].menu_categories !== null && this.data[`${control.name}`].menu_categories.length !== 0 && this.data[`${control.name}`].menu_categories[0].menu_items !== undefined && this.data[`${control.name}`].menu_categories[0].menu_items !== null) {
                  control.isNull = false;
                }
              } else {
                control.isNull = false;
              }

            }
          }
        }

        let nulls = 0;
        let notnulls = 0;
        for (const controlData of this.controlgroups[0].controlValues) {
          if (controlData.isNull === true) {
            this.controlgroups[0].isNull = true;
            this.isInfoNull = true;
            nulls++;
          } else {
            notnulls++;
          }
        }

        this.isMoreNull = nulls > notnulls;

        for (const controlData of this.controlgroups[1].controlValues) {
          if (controlData.isNull === true) {
            this.nullFacilities.push(this.data[`${controlData.name}`]);
          }
        }

        if (nulls === 0 && this.nullFacilities.length === 0) {
          localStorage.setItem('fullProfile', 'ok');
        }

        localStorage.setItem('wizard', 'true');
        this.loading = false;
      }, (err) => {
        console.log(err);
      });
    }
  }

  changeModal(next: boolean) {
    this.appHotel.modal_display$.next(next);
  }

  change() {
    this.appHotel.getStatistics(this.profile.app_hotel_id, this.selectedValue);
  }

  skip(index: number) {
    const card = document.getElementById(`card-${index}`);
    card.classList.add('skip');
    setTimeout(() => {
      card.classList.add('delete');
    }, 300);
  }

  // Get average order value
  getAverageOrderValue(): number {
    if (!this.orderSummary || !this.orderSummary.order_count || this.orderSummary.order_count === 0) {
      return 0;
    }
    return this.orderSummary.total_amount / this.orderSummary.order_count;
  }

  // Pagination methods
  updatePaginatedProducts(): void {
    const startIndex = (this.currentPage - 1) * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    this.paginatedProducts = this.filteredProducts.slice(startIndex, endIndex);
  }

  getTotalPages(): number {
    return Math.ceil(this.filteredProducts.length / this.pageSize);
  }

  nextPage(): void {
    if (this.currentPage < this.getTotalPages()) {
      this.currentPage++;
      this.updatePaginatedProducts();
      this.cdr.detectChanges();
    }
  }

  previousPage(): void {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.updatePaginatedProducts();
      this.cdr.detectChanges();
    }
  }

  getEndIndex(): number {
    const end = this.currentPage * this.pageSize;
    return end > this.filteredProducts.length ? this.filteredProducts.length : end;
  }

  // Filter products by search query
  filterProducts(): void {
    if (!this.searchQuery || this.searchQuery.trim() === '') {
      this.filteredProducts = this.top10Products.slice();
    } else {
      const query = this.searchQuery.toLowerCase().trim();
      this.filteredProducts = this.top10Products.filter(product =>
        product.description.toLowerCase().includes(query)
      );
    }
    this.currentPage = 1;
    this.updatePaginatedProducts();
    this.cdr.detectChanges();
  }

  // Clear search
  clearSearch(): void {
    this.searchQuery = '';
    this.filterProducts();
  }

  // Get selected period text for display
  getSelectedPeriodText(): string {
    switch (this.selectedValue) {
      case 'thisYear':
        return 'This Year';
      case 'lastYear':
        return 'Last Year';
      case 'thisMonth':
        return 'This Month';
      case 'lastMonth':
        return 'Last Month';
      case 'thisWeek':
        return 'This Week';
      case 'lastWeek':
        return 'Last Week';
      case 'today':
        return 'Today';
      case 'yesterday':
        return 'Yesterday';
      default:
        return 'This Year';
    }
  }

  // Get rank badge color (Gold, Silver, Bronze)
  getRankBadgeClass(index: number): string {
    switch (index) {
      case 0:
        return 'warning'; // Gold
      case 1:
        return 'light-info'; // Silver
      case 2:
        return 'light-success'; // Bronze
      default:
        return 'light'; // Default gray
    }
  }

  // Get growth rate (mock calculation)
  getGrowthRate(): number {
    if (!this.orderSummary || !this.orderSummary.total_amount) {
      return 0;
    }
    // Simple calculation: assuming 15% growth
    return 15.3;
  }

  // Get sales trend path based on selected filter
  getSalesTrendPath(): string {
    // Generate dynamic path based on order count
    const orderCount = this.orderSummary && this.orderSummary.order_count ? this.orderSummary.order_count : 0;
    const baseHeight = 80;
    
    // Create a wavy pattern based on data
    switch (this.selectedValue) {
      case 'thisYear':
      case 'lastYear':
        // 12 months trend
        return 'M0,80 L25,70 L50,60 L75,65 L100,50 L125,55 L150,45 L175,50 L200,40 L225,45 L250,35 L275,40 L300,30';
      
      case 'thisMonth':
      case 'lastMonth':
        // 30 days trend
        return 'M0,75 L40,65 L80,70 L120,55 L160,60 L200,50 L240,55 L280,45 L300,40';
      
      case 'thisWeek':
      case 'lastWeek':
        // 7 days trend
        return 'M0,80 L50,65 L100,70 L150,55 L200,60 L250,50 L300,45';
      
      case 'today':
      case 'yesterday':
        // Hourly trend (24 hours)
        return 'M0,85 L30,75 L60,80 L90,70 L120,75 L150,65 L180,70 L210,60 L240,65 L270,55 L300,50';
      
      default:
        return 'M0,80 L50,60 L100,70 L150,40 L200,50 L250,30 L300,45';
    }
  }

  // Get revenue overview period type
  getRevenueOverviewType(): string {
    switch (this.selectedValue) {
      case 'today':
      case 'yesterday':
      case 'thisWeek':
      case 'lastWeek':
        return 'daily';
      case 'thisMonth':
      case 'lastMonth':
        return 'monthly';
      case 'thisYear':
      case 'lastYear':
        return 'yearly';
      default:
        return 'monthly';
    }
  }

  // Get revenue overview labels
  getRevenueLabels(): string[] {
    const type = this.getRevenueOverviewType();
    
    if (type === 'daily') {
      return ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
    } else if (type === 'monthly') {
      return ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    } else {
      const currentYear = new Date().getFullYear();
      return [
        String(currentYear - 4),
        String(currentYear - 3),
        String(currentYear - 2),
        String(currentYear - 1),
        String(currentYear)
      ];
    }
  }

  // Get revenue bar heights (dynamic based on filter)
  getRevenueHeights(): string[] {
    const type = this.getRevenueOverviewType();
    
    if (type === 'daily') {
      return ['60%', '75%', '55%', '80%', '70%', '65%', '90%'];
    } else if (type === 'monthly') {
      return ['45%', '60%', '75%', '85%', '55%', '70%', '80%', '90%', '65%', '75%', '85%', '95%'];
    } else {
      return ['50%', '65%', '75%', '85%', '100%'];
    }
  }

  // Get chart title based on filter
  getChartTitle(): string {
    switch (this.selectedValue) {
      case 'thisYear':
        return 'This Year Trend';
      case 'lastYear':
        return 'Last Year Trend';
      case 'thisMonth':
        return 'This Month Trend';
      case 'lastMonth':
        return 'Last Month Trend';
      case 'thisWeek':
        return 'This Week Trend';
      case 'lastWeek':
        return 'Last Week Trend';
      case 'today':
        return 'Today Trend';
      case 'yesterday':
        return 'Yesterday Trend';
      default:
        return 'Sales Trend';
    }
  }

  // Get chart subtitle
  getChartSubtitle(): string {
    const type = this.getRevenueOverviewType();
    
    if (type === 'daily') {
      return 'Last 7 days';
    } else if (type === 'monthly') {
      return 'Monthly comparison';
    } else {
      return 'Last 5 years';
    }
  }

  // Get max revenue for normalization in chart
  getMaxRevenue(): number {
    if (this.last3YearsRevenue.length === 0) {
      return 100;
    }
    const amounts = this.last3YearsRevenue.map(y => y.amount);
    return Math.max.apply(null, amounts);
  }

  // Get revenue bar height percentage
  getRevenueBarHeight(amount: number): string {
    const max = this.getMaxRevenue();
    if (max === 0) {
      return '10%';
    }
    const percentage = (amount / max) * 100;
    return Math.max(percentage, 10) + '%';
  }

  // Get trend icon for top 3 products
  getTrendIcon(index: number): string {
    const icons = ['📈', '📊', '💹'];
    return icons[index] || '📊';
  }

  // Truncate text to specified length
  truncateText(text: string, maxLength: number = 30): string {
    if (!text) {
      return '';
    }
    if (text.length <= maxLength) {
      return text;
    }
    return text.substring(0, maxLength) + '...';
  }

}

